import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Paper      from '@material-ui/core/Paper'
import Table      from '@material-ui/core/Table'
import TableBody  from '@material-ui/core/TableBody'
import TableCell  from '@material-ui/core/TableCell'
import TableHead  from '@material-ui/core/TableHead'
import TableRow   from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'

import { AccountType, User } from '../../api'
import UserListEntry         from './UserListEntry'

interface UserListProps {
  accountType: AccountType | undefined
  users: User []
}

const UserList = ({ users, accountType }: UserListProps) => (
  <Paper>
    <Table style={{ tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          <TableCell>
            <FormattedMessage id={`project.${accountType}`} />
          </TableCell>
          <TableCell numeric />
        </TableRow>
      </TableHead>
      <TableBody>
        {
          !users.length && (
            <TableRow>
              <TableCell component="th" scope="row">
                <Typography variant={'caption'}>
                  <FormattedMessage id={'generic.noItems'} />
                </Typography>
              </TableCell>
            </TableRow>
          )
        }

        {users.map(user => (
          <UserListEntry key={user.id} user={user} />
        ))}
      </TableBody>
    </Table>
  </Paper>
)

export default UserList



// WEBPACK FOOTER //
// ./src/components/molecules/UserList.tsx